<div class="gallery-container">
  <div class="gallery-grid">
    @for (folder of GalleryFolders; track folder) {
      <div class="gallery-tile" (click)="openPhotos(folder)">
        @if (folder[1].indexOf('.mp4') == -1) {
          <div class="tile-image">
            <img src="assets/Gallery/{{folder[0]}}/{{folder[1]}}" alt="{{folder[0]}}"/>
          </div>
        }
        @if (folder[1].indexOf('.mp4') > -1) {
          <div class="tile-image">
            <video src="assets/Gallery/{{folder[0]}}/{{folder[1]}}" muted preload="metadata"></video>
          </div>
        }
        <div class="tile-label">{{folder[0]}}</div>
      </div>
    }
  </div>
</div>
